// /src/components/LanguageSwitcher.jsx
import React from 'react';
import { useT } from '../i18n/LanguageContext';
import { sendServerSideEvent } from '../lib/tracking';

const LanguageSwitcher = ({ className = '' }) => {
  const { lang, setLang, t } = useT();

  const switchTo = (next) => () => {
    if (next === lang) return;
    sendServerSideEvent('ButtonClick', {
      button_label: 'language-switch',
      source: 'navbar',
      target: next,
    });
    setLang(next);
  };

  const baseBtn =
    "font-['Poppins',_sans-serif] font-bold text-xs tracking-wider transition-colors px-2 py-1 rounded";
  const active = 'text-[#b03121]';
  const inactive = 'text-[#1A1A1A]/40 hover:text-[#1A1A1A]/80';

  return (
    <div
      className={`inline-flex items-center gap-1 border border-[#1A1A1A]/10 bg-white/80 rounded-full px-1.5 py-1 ${className}`}
      role="group"
      aria-label={t.lang.switchTo}
      data-testid="language-switcher"
    >
      <button
        type="button"
        onClick={switchTo('it')}
        aria-pressed={lang === 'it'}
        data-testid="lang-btn-it"
        className={`${baseBtn} ${lang === 'it' ? active : inactive}`}
      >
        {t.lang.it}
      </button>
      <span className="text-[#1A1A1A]/15 text-xs">/</span>
      <button
        type="button"
        onClick={switchTo('en')}
        aria-pressed={lang === 'en'}
        data-testid="lang-btn-en"
        className={`${baseBtn} ${lang === 'en' ? active : inactive}`}
      >
        {t.lang.en}
      </button>
    </div>
  );
};

export default LanguageSwitcher;
